export const CONTAINER_SPACING_TOP = '35%';
export const CONTAINER_SPACING_TOP_DESKTOP = '20%';
